import React, { useRef } from "react"
import "./PreviousFollowUpVisit.scss"
import moment from "moment"
import PreviousFollowUpPrint from "./PreviousFollowUpPrint"
import testLabels from "./testLabels.json"
import Print from "components/Print/Print"


export default function PreviousFollowUpAppointment({
  each,
  patientDetail,
  smartSummaryData,
  signatureJson
}: any) {

  const prevFollowUpPrintRef = useRef<any>(null)

  return (
    <>
      {each && (each?.vitals !== null || each?.followUpInfo !== null) && (
        <>
          {/* headers of consultant note - date center consultant name */}
          <div className="prev-cn-header">
            <div className="prev-cn-header-left">
              {each?.scheduleDate && (
                <span>{moment(each.scheduleDate).format("DD-MM-YYYY")}</span>
              )}
              {each?.centerName && <span>&emsp;&emsp;{each.centerName}</span>}
              {each?.consultantName && each?.appointmentType !== "HC" ? (
                <span>&emsp;&emsp;{each.consultantName}</span>
              ) : each?.primaryConsultantName ? (
                <span>&emsp;&emsp;{each.primaryConsultantName}</span>
              ) : null}
              {each?.appointmentType === "HC" && (
                each?.consultantName ? (
                  <span>&emsp;&emsp; S/b - HC {each.consultantName}</span>
                ) : each?.primaryConsultantName ? (
                  <span>&emsp;&emsp; S/b - HC {each.primaryConsultantName}</span>
                ) : null
              )}
            </div>

            <div>
              <Print
                componentRef={prevFollowUpPrintRef}
                documentTitle={`Consultant Notes ${patientDetail?.mocId} ${patientDetail?.name} ${moment(each.scheduleDate).format("DD/MM/YYYY")}`}
              />
            </div>
          </div>
          <div className="prev-cn-container">
            {/* vitals of corresponding consultant note */}
            <div className="prev-cn-vital">
              {
                testLabels?.map((item, viIndex) => {
                  const value = each?.vitals?.[item?.field];
                  return value ? (
                    <div className="prev-cn-vital-item" key={viIndex}>
                      <span className="prev-cn-label">{item?.label}:</span>&nbsp;
                      <span>{value}</span>&nbsp;
                      <span>{item?.units}</span>&nbsp;
                    </div>
                  ) : null;
                })
              }
            </div>
            {/* consultant notes filled fields */}
            {each?.followUpInfo?.briefHistory ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Brief History: </span>{each?.followUpInfo?.briefHistory}
              </div>
            ) : null}

            {each?.followUpInfo?.complaints ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Complaints: </span>{each?.followUpInfo?.complaints}
              </div>
            ) : null}

            {each?.followUpInfo?.examination ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Examination: </span>{each?.followUpInfo?.examination}
              </div>
            ) : null}

            {each?.followUpInfo?.clinicalImpressions ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Clinical Impressions: </span>{each?.followUpInfo?.clinicalImpressions}
              </div>
            ) : null}

            {each?.followUpInfo?.notes ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Notes: </span>{each?.followUpInfo?.notes}
              </div>
            ) : null}
            {each?.followUpInfo && each?.followUpInfo?.prescriptionPad && each?.followUpInfo?.prescriptionPad?.length > 0 ? (
              each?.followUpInfo?.prescriptionPad?.map((pres: any, presIndex: any) => {
                return (
                  <div className="prev-cn-prescription">
                    <div>
                      <span className="prev-cn-label">Prescription: </span>
                    </div>
                    <table className="prev-cn-table">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Type</th>
                          <th>Medicine</th>
                          <th>Dose</th>
                          <th>When</th>
                          <th>Frequency</th>
                          <th>Duration</th>
                          <th>Notes/Instructions</th>
                          <th>Side Effects</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pres?.medicines?.map((e: any, i: any) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{e?.type}</td>
                            <td>{e?.medicineName}</td>
                            <td>{e?.dose}</td>
                            <td>{e?.when}</td>
                            <td>{e?.frequency}</td>
                            <td>{e?.duration}</td>
                            <td>{e?.instructions}</td>
                            <td>
                              <ul>
                                {e?.selectedSideEffects?.map(
                                  (sideEffect: any) => {
                                    return <li className="pres-list">{sideEffect}</li>
                                  }
                                )}
                              </ul>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              })
            ) : null}

            {each?.followUpInfo && each?.followUpInfo?.testsRequired && each?.followUpInfo?.testsRequired?.length > 0 ? (
              each?.followUpInfo?.testsRequired?.map((test: any, testIndex: any) => {
                return (
                  <div className="prev-cn-prescription">
                    <div>
                      <span className="prev-cn-label">Test Required: </span>
                    </div>
                    <table className="prev-cn-table">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Test</th>
                          <th>Instructions</th>
                          <th>When</th>
                        </tr>
                      </thead>
                      <tbody>
                        {test?.tests?.map((e: any, i: any) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              {e?.testName}
                            </td>
                            <td>{e?.instructions}</td>
                            <td>{e?.when && moment(e?.when).format(
                              "DD-MM-YYYY")}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              })
            ) : null}

            {each?.appointmentType && each?.appointmentType === "HC" && each?.servicesRendered && each?.servicesRendered?.length > 0 ? (
              <div className="prev-cn-prescription">
                <div>
                  <span className="prev-cn-label">Services Rendered: </span>
                </div>
                <table className="prev-cn-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Type</th>
                      <th>Completed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {each?.servicesRendered?.map((e: any, i: any) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{e?.serviceTemplateName}</td>
                        <td>{e?.completedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : null}

            {each?.followUpInfo?.advice ? (
              <div className="prev-cn-text prev-advice">
                <span className="prev-cn-label">Advice: </span>{each?.followUpInfo?.advice}
              </div>
            ) : null}

            {each?.followUpInfo?.nextVisit ? (
              <div className="prev-cn-text">
                <span className="prev-cn-label">Next Visit: </span>
                {each?.followUpInfo?.nextVisit}
              </div>
            ) : null}

            {each?.followUpInfo?.referredTo?.length > 0 ? (
              each?.followUpInfo?.referredTo?.map((ref: any, refIndex: any) => {
                return (
                  <>
                    <div className="prev-cn-label">Referred To:</div>
                    <div className="prev-cn-referred-to">
                      {ref?.speciality ? (
                        <div>
                          <span className="prev-cn-label">Speciality: </span>{ref?.speciality}
                        </div>
                      ) : null}

                      {ref?.doctorName ? (
                        <div>
                          <span className="prev-cn-label">Doctor Name: </span>{ref?.doctorName}
                        </div>
                      ) : null}

                      {ref?.emailId ? (
                        <div>
                          <span className="prev-cn-label">Email Id: </span>{ref?.emailId}
                        </div>
                      ) : null}

                      {ref?.phoneNo ? (
                        <div>
                          <span className="prev-cn-label">Phone No: </span>{ref?.phoneNo}
                        </div>
                      ) : null}
                    </div>
                  </>
                )
              })
            ) : null}

          </div>
          <div className="add-space-bottom"></div>
        </>
      )}
      {/* print corresponding consultant note */}
      <PreviousFollowUpPrint
        followUpData={each?.followUpInfo}
        servicesRendered={each?.servicesRendered}
        appointmentType={each?.appointmentType}
        appointmentDate={each.scheduleDate}
        patientDetail={patientDetail}
        componentRef={prevFollowUpPrintRef}
        templateJSON={signatureJson}
        smartSummaryData={smartSummaryData}
        vital={each?.vitals}
        testLabels={testLabels}
      />
    </>
  )




}